const CALL_OUTCOME = {
  FIRST_APPT: 'FirstAppt',
  CALLBACK: 'Callback',
  EMAIL_SENT: 'EmailSent',
  HANG_UP: 'HangUp',
  NOT_INTERESTED: 'NotInterested',
  NO_ANS: 'NoAns',
  DO_NOT_CALL: 'DoNotCall',
  DISCARDED: 'Discarded',
  NEW_CONTACT: 'NewContact',
  BLANK: 'Blank',
};

export const CALL_OUTCOME_LABEL_MAP = {
  [CALL_OUTCOME.FIRST_APPT]: 'Booked an appointment',
  [CALL_OUTCOME.CALLBACK]: 'Scheduled a callback',
  [CALL_OUTCOME.EMAIL_SENT]: 'Send an email',
  [CALL_OUTCOME.HANG_UP]: 'Hung up',
  [CALL_OUTCOME.NOT_INTERESTED]: 'Not interested',
  [CALL_OUTCOME.NO_ANS]: 'No answer',
  [CALL_OUTCOME.DO_NOT_CALL]: 'Do Not Call',
  [CALL_OUTCOME.DISCARDED]: 'Discarded',
  [CALL_OUTCOME.NEW_CONTACT]: 'New Contact',
  [CALL_OUTCOME.BLANK]: 'Blank',
};

export const CALL_OUTCOME_OPTIONS = [
  {
    label: CALL_OUTCOME_LABEL_MAP[CALL_OUTCOME.FIRST_APPT],
    value: CALL_OUTCOME.FIRST_APPT,
  },
  {
    label: CALL_OUTCOME_LABEL_MAP[CALL_OUTCOME.CALLBACK],
    value: CALL_OUTCOME.CALLBACK,
  },
  {
    label: CALL_OUTCOME_LABEL_MAP[CALL_OUTCOME.EMAIL_SENT],
    value: CALL_OUTCOME.EMAIL_SENT,
  },
  {
    label: CALL_OUTCOME_LABEL_MAP[CALL_OUTCOME.HANG_UP],
    value: CALL_OUTCOME.HANG_UP,
  },
  {
    label: CALL_OUTCOME_LABEL_MAP[CALL_OUTCOME.NOT_INTERESTED],
    value: CALL_OUTCOME.NOT_INTERESTED,
  },
  {
    label: CALL_OUTCOME_LABEL_MAP[CALL_OUTCOME.NO_ANS],
    value: CALL_OUTCOME.NO_ANS,
  },
  {
    label: CALL_OUTCOME_LABEL_MAP[CALL_OUTCOME.DO_NOT_CALL],
    value: CALL_OUTCOME.DO_NOT_CALL,
  },
  {
    label: CALL_OUTCOME_LABEL_MAP[CALL_OUTCOME.DISCARDED],
    value: CALL_OUTCOME.DISCARDED,
  },
  {
    label: CALL_OUTCOME_LABEL_MAP[CALL_OUTCOME.NEW_CONTACT],
    value: CALL_OUTCOME.NEW_CONTACT,
  },
  {
    label: CALL_OUTCOME_LABEL_MAP[CALL_OUTCOME.BLANK],
    value: CALL_OUTCOME.BLANK,
  },
];

export const CALL_DURATION = {
  MIN: 0,
  MAX: 1800,
  STEP: 5,
  SECONDS_IN_MINUTE: 60,
  SECONDS_IN_HOUR: 3600,
};

export const CALL_LOG_DETAILS_ITEM = {
  PLAYBACK: 'Playback',
  TRANSCRIPT: 'Transcript',
  AIDENTIFIED_DATA: 'View Aidentified data',
};

export const RECORDING_RELATED_DETAILS_ITEMS = [
  CALL_LOG_DETAILS_ITEM.PLAYBACK,
  CALL_LOG_DETAILS_ITEM.TRANSCRIPT,
];
